import React, { useState } from 'react';

import { Svg } from 'src/components/Svg/Svg';
import { ButtonLink } from 'src/components/Button/ButtonLink';
import { RichText } from 'src/components/RichText/RichText';

import type { ProductPromotion } from '../utils/product-detail.types';

import classes from './PromotionsBlock.module.scss';

export type PromotionsBlockProps = {
    promotion: ProductPromotion;
};

/**
 * PromotionsBlock component
 * @param props
 * @constructor
 */
export function PromotionsBlock(props: PromotionsBlockProps) {
    const [toggleDropdown, setToggleDropdown] = useState(false);
    const isExternal = props.promotion.pdpLink?.includes('http');

    return (
        <div className={classes.promotion}>
            <h2 className={classes.promotionTitle}>{props.promotion.pdpLabel}</h2>

            {props.promotion.pdpDescription && (
                <p className={classes.promotionDesc}>
                    <RichText className={classes.promotionTerms} content={props.promotion.pdpDescription} />
                </p>
            )}

            {props.promotion.pdpTermsAndConditions && (
                <>
                    <button
                        className={classes.promotionTrigger}
                        type="button"
                        aria-label="Click to view th terms and conditon of this promotion"
                        onClick={() => setToggleDropdown(!toggleDropdown)}
                        data-ui-active={toggleDropdown}
                    >
                        Terms and Conditions <Svg name="arrow-down" />
                    </button>

                    {toggleDropdown && (
                        <div>
                            <RichText
                                className={classes.promotionTerms}
                                content={props.promotion.pdpTermsAndConditions}
                            />
                        </div>
                    )}
                </>
            )}

            {props.promotion.pdpLink && props.promotion.pdpLinkText && (
                <ButtonLink
                    external={isExternal}
                    target={isExternal ? '_blank' : '_self'}
                    to={props.promotion.pdpLink}
                    style={{
                        backgroundColor: props.promotion.pdpLinkBackground,
                        color: props.promotion.pdpLinkTextColour,
                    }}
                >
                    {props.promotion.pdpLinkText}
                </ButtonLink>
            )}
        </div>
    );
}
